module.exports = __webpack_public_path__ + "img/mn.ce2d7030.svg";